(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sim-home-slider"] && !Shopify.designMode) return;
  try {
    
function setupSimSliders(root) {
  root.querySelectorAll('.sim-slider').forEach(slider => {
    if (slider.dataset.ready) return;
    slider.dataset.ready = 'true';
    const rail = slider.querySelector('.sim-slider__rail');
    const slides = rail.querySelectorAll('.sim-slide');
    const dots = slider.querySelectorAll('[data-slide]');
    let active = 0;
    const go = index => {
      index = (index + slides.length) % slides.length;
      rail.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    slider.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => go(active + Number(button.dataset.direction))));
    dots.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
    rail.addEventListener('scroll', () => {
      active = Math.round(rail.scrollLeft / rail.clientWidth);
      dots.forEach((dot, index) => index === active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    }, {passive:true});
    rail.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        go(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
  });
}
setupSimSliders(document);
document.addEventListener('shopify:section:load', event => setupSimSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sim-studio-november"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sim-campaign-carousel')) {
  customElements.define('sim-campaign-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-campaign-slide]')];
      this.controls = this.querySelector('[data-carousel-controls]');
      if (this.slides.length < 2 || !this.controls) return;
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.inView = true;
      this.endsAt = Date.parse(this.dataset.endsAt);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const listen = (target, event, fn) => target.addEventListener(event, fn, { signal: this.controller.signal });
      this.controls.hidden = false;
      listen(this, 'click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-slide-to')) this.show(Number(button.dataset.slideTo));
        if (button.hasAttribute('data-previous')) this.show(this.index - 1);
        if (button.hasAttribute('data-next')) this.show(this.index + 1);
        if (button.hasAttribute('data-pause')) {
          this.paused = !this.paused;
          button.setAttribute('aria-pressed', String(this.paused));
          button.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
        }
        this.schedule();
      });
      listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => this.schedule());
      this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.schedule(); });
      this.observer.observe(this);
      if (Number.isFinite(this.endsAt)) this.expiryTimer = setTimeout(() => this.expire(), Math.max(0, this.endsAt - Date.now()));
      this.schedule();
    }
    expire() {
      if (!Number.isFinite(this.endsAt) || Date.now() < this.endsAt) return false;
      clearTimeout(this.timer);
      this.slides.forEach((slide, index) => { slide.hidden = index !== 0; slide.inert = index !== 0; });
      this.controls.hidden = true;
      return true;
    }
    show(index) {
      if (this.expire()) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.querySelectorAll('[data-slide-to]').forEach((button, i) => {
        if (i === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.expire() || this.paused || this.hovered || this.focused || !this.inView || document.hidden || this.motion.matches) return;
      this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 15000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.expiryTimer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
